import { Alert, Button, AlertTitle, SxProps, Theme } from "@mui/material";
import { ReactNode, Fragment } from "react";
import { ApiError, isApiError } from "services/api/misc";
import { KeyedMutator } from "swr";

interface IErrorBoundaryProps {
  error?: Error | ApiError;
  onRetry?: (() => void) | KeyedMutator<any>;
  children: ReactNode[] | ReactNode;
  hasMargin?: boolean;
  sx?: SxProps<Theme>;
}

export const ErrorBoundary = (props: IErrorBoundaryProps) => {
  const { error, children, onRetry, hasMargin = true, sx } = props;
  if (error) {
    console.warn("ErrorBoundary", error);
  }
  return (
    <Fragment>
      {error && (
        <Alert
          sx={{ ...(hasMargin ? { marginTop: "24px", marginBottom: "24px" } : undefined), ...{ width: "100%" }, ...sx }}
          severity="error"
          action={
            onRetry ? (
              <Button
                color="inherit"
                size="small"
                onClick={() => {
                  if (onRetry.length === 0) {
                    onRetry();
                  } else {
                    onRetry(undefined, { revalidate: true });
                  }
                }}
              >
                RETRY
              </Button>
            ) : undefined
          }
        >
          <AlertTitle>{error.message}</AlertTitle>
          {isApiError(error) && `Support Code: ${error.code}`}
        </Alert>
      )}
      {!error && children}
    </Fragment>
  );
};

export const errorMessage = (
  error: any,
  defaultMessage: string = "Something unexpected occurred, try again later."
): string => {
  console.warn("errorMessage", error);
  if (error instanceof Error) {
    return error.message && error.message.length > 0 ? error.message : defaultMessage;
  }
  return defaultMessage;
};
